// this.$store.state.vinculacion
import { serverTimestamp } from "firebase/firestore";

// CLASE VINCULACION
export const vinculacion = class {
  constructor(privilegios) {
    return {
      id: "",
      idUsuario: "",
      idEmpresa: "",
      idHorario: "",
      idCargo: "",
      modalidad: "",
      estado: "Pendiente",
      privilegios: privilegios.definir(),
      esInvitado: false,
      esPropietario: false,
      esContratista: false,
      registro: {
        idUsuario: "",
        estado: "Creado",
        creacion: serverTimestamp(),
        actualizacion: serverTimestamp(),
      },
    };
  }
};
